module.exports = __webpack_public_path__ + "img/1.7ac81b9c.png";